import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    path: '*',
    lang: '', // 'id',
	isAuthenticated: false,
	isAdmin: false,
    playlist: []
    // playlist: [
    //   {
    //     path: 'iklan',
    //     name: 'Iklan'
    //   },
    //   {
    //     path: 'iklan2',
    //     name: 'Iklan 2',
    //   },
    //   {
    //     path: 'video-bri',
    //     name: 'Video BRI',
    //   },
    //   {
    //     path: 'video-bri2',
    //     name: 'Video BRI 2',
    //   },
    //   {
    //     path: 'video-tax-amnesty',
    //     name: 'Video TAX Amnesty',
    //   },
    //   {
    //     path: 'video-pariwisata',
    //     name: 'Video Pariwisata'
    //   }
    // ]

    // playlist: [
    //     {
    //       path: 'iklan',
    //       name: 'Iklan 1'
    //     },
    //     {
    //       path: 'iklan2',
    //       name: 'Iklan 2',
    //     },
    //     {
    //       path: 'video-bri',
    //       name: 'Video 1',
    //     },
    //     {
    //       path: 'video-bri2',
    //       name: 'Video 2',
    //     },
    //     {
    //       path: 'video-tax-amnesty',
    //       name: 'Video 3',
    //     },
    //     {
    //       path: 'video-pariwisata',
    //       name: 'Video 4'
    //     }
    //   ]
  },
  mutations: {

  },
  actions: {

  }
})
